import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'Helpers/encodeParams'
import extractApiData from 'Helpers/extractApiData'

const endpoints = ((baseURL) => {
  return {
    getSmsMessages: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/message/search?${encodeParams(params)}`,
    getSmsSendings: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/sending/search?${encodeParams(params)}`,
    getSMSMessagesMonthly: (idList) =>
      `${baseURL}/api/statistics/list/${idList}/sendingvolumes/monthly`,
    getSMSRecentlySent: (idList, params) =>
      `${baseURL}/api/list/${encodeURIComponent(
        idList
      )}/message/search?${encodeParams(params)}`,
    getCountOfSMSSent: (idMessage) =>
      `${baseURL}/api/statistics/message/${idMessage}/count/sent`,
    getSenderStatus: `${baseURL}/api/sender/status`,
    getCodeSmsConfirm: `${baseURL}/api/sender/getcode`,
    confirmSmsNumericSender: `${baseURL}/api/sender/confirm`
  }
})(process.env.BESMSSEND_URL)

/**
 * @description Gets the SMS sending details
 * @param {number} idList
 * @param {Object} params
 * @param {number} params.pageNum
 * @param {number} params.pageSize
 * @param {string} params.orderAsc
 * @param {Object} data
 * @param {number} data.SentThreshold
 * @param {string} data.DateFrom
 * @param {string} data.DateTo
 * @param {boolean} data.Completed
 * @param {boolean} data.Started
 * @returns
 */
export const beSMSSendGetSmsSendings = (idList, params, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSmsSendings(idList, params),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

/**
 * @description Gets the SMS sending details
 * @param {number} idList
 * @param {Object} params
 * @param {number} params.pageNum
 * @param {number} params.pageSize
 * @param {string} params.orderAsc
 * @param {Object} data
 * @param {number} data.SentThreshold
 * @param {string} data.DateFrom
 * @param {string} data.DateTo
 * @param {boolean} data.Completed
 * @param {boolean} data.Started
 * @returns
 */
export const beSMSSendGetSmsMessages = (idList, params, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSmsMessages(idList, params),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beSMSSendGetSMSMessagesMonthly = (idList, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSMSMessagesMonthly(idList),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beSMSSendGetCountOfSMSSent = (idMessage) => {
  const url = endpoints.getCountOfSMSSent(idMessage)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}

/**
 * @typedef {Object} TrustedSenderStatusResponse
 * @property {('NotConfirmed'|'Confirmed'|'ToBeConfirmed'|'Blocked')} Status
 * @property {string} Description
 *
 * @description Get a registered Sms sender status. 

 * @param {string} SenderNumber
 * @returns {TrustedSenderStatusResponse} Trusted sender status response
 */
export const beSMSSendGetSenderStatus = (SenderNumber) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getSenderStatus,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      SenderNumber
    })
  }).then(({ data }) => data)
}

export const beSMSSendConfirmSmsNumericSender = (SenderNumber, ConfirmCode) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.confirmSmsNumericSender,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      SenderNumber,
      ConfirmCode
    })
  }).then(({ data }) => data)
}

export const beSMSSendGetCodeSmsConfirm = (SenderNumber) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.getCodeSmsConfirm,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({
      SenderNumber
    })
  }).then(({ data }) => data)
}

export const TRUSTED_SENDER_STATUS_NOT_CONFIRMED = 'NotConfirmed'
export const TRUSTED_SENDER_STATUS_CONFIRMED = 'Confirmed'
export const TRUSTED_SENDER_STATUS_TO_BE_CONFIRMED = 'ToBeConfirmed'
export const TRUSTED_SENDER_STATUS_BLOCKED = 'Blocked'

export const TRUSTED_SMS_CONFIRM_STATUS_VALID = 'Valid'
export const TRUSTED_SMS_CONFIRM_STATUS_WRONG = 'Wrong'
export const TRUSTED_SMS_CONFIRM_STATUS_REVOKED = 'Revoked'
export const TRUSTED_SMS_CONFIRM_STATUS_EXPIRED = 'Expired'
